import { Button, Form, Input, notification, Typography } from "antd";
import { AxiosError } from "axios";
import LoginIcon from "icons/LoginIcon";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useLogin } from "services/auth";
import { useAsyncGetUserMe } from "services/user";
import useAuthStore from "stores/auth";
import { ILogin } from "types/auth";

const { Text } = Typography;
const LoginForm = () => {
  const { setToken } = useAuthStore();
  const { mutateAsync } = useAsyncGetUserMe();
  const [isLoginError, setIsLoginError] = useState<boolean>(false);
  const navigation = useNavigate();

  const { loginAsync, isPending } = useLogin();
  const handleOnLogin = async (value: ILogin) => {
    try {
      const result = await loginAsync({
        email: value.email,
        password: value.password,
      });
      setToken(result.data.accessToken, result.data.refreshToken);
      await mutateAsync();
      navigation("/");
    } catch (e) {
      if (e instanceof AxiosError && e.response) {
        // Check for specific error messages
        if (e.response.data.message === "User not approved") {
          notification.error({
            message: "เข้าสู่ระบบล้มเหลว",
            description: "กรุณารอเจ้าหน้าที่ยืนยันข้อมูล",
            placement: "topRight",
          });
        }
        if (e.response.data.message === "Invalid Email or Password") {
          setIsLoginError(true);
        }
        //
      } else {
        // Handle non-Axios errors (optional)
        console.error("An unexpected error occurred:", e);
      }
    }
  };

  return (
    <div className="flex flex-col justify-center pt-10">
      <div className="font-semibold mb-8">ยินดีต้อนรับเข้าสู่ระบบ</div>
      <Form onFinish={handleOnLogin}>
        <div className="mb-12">
          <Form.Item
            required
            name="email"
            rules={[{ required: true, message: "กรุณากรอกอีเมล" }]}
          >
            <Input placeholder="อีเมล" size="large" />
          </Form.Item>
        </div>
        <Form.Item
          required
          name="password"
          rules={[{ required: true, message: "กรุณากรอกรหัสผ่าน" }]}
        >
          <Input.Password placeholder="รหัสผ่าน" size="large" />
        </Form.Item>
        {isLoginError && (
          <Text type="danger" className="text-center">
            อีเมล หรือ รหัสผ่านไม่ถูกต้อง
          </Text>
        )}
        {/* <Link to="/forgetpassword">
          <div className="text-end text-primary-700 cursor-pointer">
            ลืมรหัสผ่าน
          </div>
        </Link>
 */}
        <div className="text-center mt-20">
          <Button
            className="w-[200px]"
            size="large"
            type="primary"
            icon={<LoginIcon />}
            htmlType="submit"
            loading={isPending}
          >
            เข้าสู่ระบบ
          </Button>
        </div>
      </Form>
    </div>
  );
};
export default LoginForm;
